import React, { useState } from 'react'
import { deleteAccount } from '../application/asyncActions'
import { useInvestor } from '../application/features/investor/useInvestor'
import { useTermsAndConditions } from '../application/features/investor/useTermsAndConditions'
import { useLogout } from '../application/hooks'
import { useAppDispatch } from '../application/store'
import { GenericError } from '../components/Error'
import { PayloadUnwrapper } from '../components/Error/PayloadUnwrapper'
import { TermsModal } from '../components/TermsModal'

export const SSOTermsAcceptanceModalConnected: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const dispatch = useAppDispatch()
  const [isOpen, setIsOpen] = useState(true)
  const { investor } = useInvestor()
  const { logout } = useLogout()
  const termsAndConditions = useTermsAndConditions(investor)

  return (
    <PayloadUnwrapper
      customError={<GenericError onClick={() => window.location.reload()} onLogoutClick={() => logout()} />}
      item={termsAndConditions}
    >
      {({ showTermsAcceptanceModal, acceptTermsAndConditions }) => (
        <>
          {showTermsAcceptanceModal && (
            <TermsModal
              open={isOpen}
              handleAcceptance={() => {
                setIsOpen(false)
                acceptTermsAndConditions()
              }}
              handleNonAcceptance={() => dispatch(deleteAccount())}
            />
          )}
          {children}
        </>
      )}
    </PayloadUnwrapper>
  )
}
